import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { EventService } from '../../../services/event.service';
import { AnnualProgramService } from '../../../services/annual-program.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import StoreEventStation from '../../../interfaces/StoreEventStation';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { HelperService } from '../../../services/helper.service';


interface Logbook {
  type: any;
  activity_type: string;
  date: any;
  dateFormat: string;
  start_time: string;
  end_time: string;
  image: any;
  responsable: string;
  fields?: any;
  external_staff: {
    provider: '',
    responsable: '',
  };
}

interface Event {
  id: string;
  name: string;
  custom_name?: string;
  event: Array<string>;
  custom_event?: string;
  element: string;
  custom_element?: string;
  activity: string;
  custom_activity?: string;
  frequency: string;
  description: string;
  custom_frequency?: {
    number: string;
    frequency: string;
  };
  date: any;
}
@Component({
  selector: 'ngx-add-edit-event-cleaning-annual-program',
  templateUrl: './add-edit-event-cleaning-annual-program.component.html',
  styleUrls: ['./add-edit-event-cleaning-annual-program.component.scss']
})
export class AddEditEventCleaningAnnualProgramComponent implements OnInit {
  @Input() edit = false;
  @Input() addDefaultEvent = false;
  @Input() event?: any;
  @Input() defaultEvent?: any;
  @Input() stationId: string;
  showCustomEvent = false;
  //loading = false;
  catalog: any = {
    activities: [],
    elements: [],
    frequencies: [],
    names: [],
    types: []
  }
  formData: Event = {
    id: '0',
    name: '',
    event: [],
    element: '',
    activity: '',
    frequency: '',
    description: '',
    date: new Date(),
    custom_frequency: {
      number: '',
      frequency: '',
    },
  };

  // Cleaning
  loading = false;
  employees = [];
  externalStaff = [];
  images = [];
  uploadPercent: any;
  downloadURLs = [];
  authorizations = [];
  uploads = [];
  logbook: any = {
    type: 10,
    activity_type: '',
    dateFormat: '',
    date: new Date(),
    start_time: moment().format('H:mm'),
    end_time: moment().format('H:mm'),
    image: '',
    responsable: '',
    external_staff: {
      provider: '',
      responsable: '',
    },
    fields: {
      period: 'daily',
      amount_waste_generated: 0,
    },
  };
  monthlyActivities = [
    {
      id: 1,
      name: 'floor_washing_dispatch_area',
      label: 'Lavado de pisos en área de despacho',
      quantity: 0,
      value: false,
    },
    {
      id: 2,
      name: 'cleaning_storage_area',
      label: 'Limpieza en zona de almacenamiento',
      quantity: 0,
      value: false,
    },
    {
      id: 3,
      name: 'cleaning_registers_grates',
      label: 'Limpieza de registros y rejillas',
      quantity: 0,
      value: false,
    },
    {
      id: 4,
      name: 'registers_grates_inspection',
      label: 'Inspección de registros y regillas',
      quantity: 0,
      value: false,
    },
    {
      id: 5,
      name: 'gas_trap_inspection_cleaning',
      label: 'Inspección y limpieza a trampa de grasas',
      quantity: 0,
      value: false,
    },
  ];
  quarterlyActivities = [
    {
      id: 1,
      name: 'drain_cleaning',
      label: 'Limpieza de drenajes',
      quantity: 0,
      value: false,
    },
    {
      id: 2,
      name: 'scrub_drains',
      label: 'Desazolve drenajes',
      quantity: 0,
      value: false,
    },
  ];
  // End Attributes

  constructor(
    protected ref: NbDialogRef<AddEditEventCleaningAnnualProgramComponent>,
    private annualProgramService: AnnualProgramService,
    private eventService: EventService,
    private helperService: HelperService,
  ) { }

  async ngOnInit() {
    await this.getCatalog();
    if (this.addDefaultEvent) {
      //console.log(this.defaultEvent)
      this.logbook.fields.period = this.defaultEvent.fields.period;
      if (this.logbook.fields.period === 'diario') {
        this.logbook.fields = this.defaultEvent.fields
      }
      if (this.logbook.fields.period === 'mensual') {
        this.logbook.fields.type_waste_generated = this.defaultEvent.fields.type_waste_generated
        this.logbook.fields.description_activity = this.defaultEvent.fields.description_activity
        this.logbook.fields.no_toxic = this.defaultEvent.fields.no_toxic
        this.monthlyActivities = this.defaultEvent.fields.monthlyActivities
      }
      if (this.logbook.fields.period === 'trimestral') {
        this.logbook.fields.type_waste_generated = this.defaultEvent.fields.type_waste_generated
        this.logbook.fields.description_activity = this.defaultEvent.fields.description_activity
        this.quarterlyActivities = this.defaultEvent.fields.quarterlyActivities
      }
      return;
    }
    if (this.event) {
      this.logbook = this.event

      if (this.logbook.fields.period === 'mensual') {
        this.monthlyActivities = this.logbook.fields.monthlyActivities;
      }

      if (this.logbook.fields.period === 'trimestral') {
        this.quarterlyActivities = this.logbook.fields.quarterlyActivities;
      }
    }
  }

  validateForm() {
    this.store()
  }

  async getCatalog() {
    this.loading = true;
    const [error, response] = await this.annualProgramService.getAnnualProgramNewCatalog();
    this.loading = false
    if (error) return this.alert('Error', 'error', 'Hubo un error al consultar el catalogo');
    this.catalog = response.data
    this.catalog.types = this.catalog.types.map(type => type.toLowerCase())
    //console.error(this.catalog)
  }

  prepareData() {
    this.catalog.types = this.catalog.types.map(catalog => { return { label: catalog, selected: false } })
  }

  dismiss() {
    this.ref.close(false);
  }

  async calculateQuarterlyValues() {
    this.logbook.fields.amount_waste_generated = await Number(this.quarterlyActivities[0].quantity) + Number(this.quarterlyActivities[1].quantity);
  }

  async calculateMonthlyValues() {
    this.logbook.fields.amount_waste_generated = await Number(this.monthlyActivities[0].quantity) + Number(this.monthlyActivities[1].quantity) + Number(this.monthlyActivities[2].quantity) + Number(this.monthlyActivities[3].quantity) + Number(this.monthlyActivities[4].quantity);
  }

  async store() {
    const validDataHasEmptyFields = Object.keys(this.logbook).includes('');
    const validFieldsHasEmptyFields = Object.keys(this.logbook.fields).includes('');
    if (validDataHasEmptyFields || validFieldsHasEmptyFields) return this.alert('Ingresa todos los datos necesiarios', 'error');
    this.loading = true;
    if (this.logbook.fields.period === 'mensual') this.logbook.fields.monthlyActivities = this.monthlyActivities;
    if (this.logbook.fields.period === 'trimestral') this.logbook.fields.quarterlyActivities = this.quarterlyActivities;
    const [error, result]: any = await this.eventService.storeCleaningEvent(this.stationId, this.logbook, { column_field: 'period' });
    const logbookId = result.data.id;
    if (error) {
      this.loading = false;
      return this.alert('Oops, intenta más tarde', 'error');
    }

    this.loading = false;
    await this.alert('Éxito', 'success', 'Se creo el evento')
    this.ref.close(true);
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '', html: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
      html: html,
    });
  }

  checkIfSelectCustom() {
    const findCustom = this.formData.event.find(event => event === 'custom');
    console.error(this.formData.event, findCustom);
    if (findCustom) return this.showCustomEvent = true;
    this.formData.custom_event = '';
    this.showCustomEvent = false;
  }

  async editEvent () {
    this.loading = true;
    const [error] = await this.eventService.updateCleaningEvent(this.logbook.id, { ...this.logbook });
    this.loading = false;
    if (error) {
      let html = ''
      if (error.error  && error.error.error) for (const message of error.error.error) html += `<span>${message}</span><br>`
      else html = error.message
      return this.alert('Error', 'error', '', html);
    }
    await this.alert('Éxito', 'success', 'Se edito el evento')
    this.ref.close(true);
  }

  searchElements = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['elements'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchNames = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['names'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchActivities = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['activities'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchServices = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['types'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

}
